import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Case } from '@/types';

interface CasesResponse {
  cases: Case[];
  pageCount: number;
  totalCount: number;
}

export const useCasesQuery = ({
  matterId,
  searchText,
  pageQuery,
}: {
  matterId: string | null;
  searchText: string;
  pageQuery: number;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<CasesResponse>(
    [QueryEntity.Case, { matterId }, searchText, pageQuery],
    async () => {
      const cleanSearchText = searchText?.replace(/\s+/g, ' ').trim() || '';
      return fetch(
        `${APIBaseChronos}/api/matters/${matterId}/cases?search=${cleanSearchText}&page=${pageQuery}`,
        fetchConfigGET,
      ).then((res) => res.json());
    },
    {
      keepPreviousData: true,
    },
  );
};
